import TemplatePageLayout from './template-page-layout';

export { TemplateBackground } from './template-page-layout';

export default TemplatePageLayout;
